import { View } from 'foundations-components/components/View';
import CompanionTabWrapper from './CompanionTabWrapper';
import QuizMeTab from './QuizMeTab';
import { jsx as _jsx } from "react/jsx-runtime";
const AICompanionTabs = ({
  contentId,
  contentType
}) => {
  return /*#__PURE__*/_jsx(View, {
    marginBlockStart: "400",
    children: /*#__PURE__*/_jsx(CompanionTabWrapper, {
      children: /*#__PURE__*/_jsx(QuizMeTab, {
        contentId: contentId,
        contentType: contentType
      })
    })
  });
};
export default AICompanionTabs;